import React, { useState, useEffect } from 'react';
import NavigationBar from '../layout/NavigationBar';
import Footer from '../layout/footer';
import axios from 'axios';
import api from '../api/axiosInstance';
import { toast } from 'react-toastify';

const CreatePaymentAccount = () => {
    const [stepCompleted, setStepCompleted] = useState({
        step1: false,
        step2: false,
        step3: false
    });
    const [originalStepData, setOriginalStepData] = useState({
        step1: {},
        step2: {},
        step3: {}
    });
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [accountId, setAccountId] = useState('');
    const [productId, setProductId] = useState('');

    const statesOfIndia = [
        'Andhra Pradesh',
        'Arunachal Pradesh',
        'Assam',
        'Bihar',
        'Chhattisgarh',
        'Goa',
        'Gujarat',
        'Haryana',
        'Himachal Pradesh',
        'Jharkhand',
        'Karnataka',
        'Kerala',
        'Madhya Pradesh',
        'Maharashtra',
        'Manipur',
        'Meghalaya',
        'Mizoram',
        'Nagaland',
        'Odisha',
        'Punjab',
        'Rajasthan',
        'Sikkim',
        'Tamil Nadu',
        'Telangana',
        'Tripura',
        'Uttar Pradesh',
        'Uttarakhand',
        'West Bengal',
    ];

    const statesCitiesMap = {
        'Andhra Pradesh': ['Adoni', 'Amaravati', 'Anantapur', 'Chandragiri', 'Chittoor', 'Dowlaiswaram', 'Eluru', 'Guntur', 'Kadapa', 'Kakinada', 'Kurnool', 'Machilipatnam', 'Nagarjunakoṇḍa', 'Rajahmundry', 'Srikakulam', 'Tirupati', 'Vijayawada', 'Visakhapatnam', 'Vizianagaram', 'Yemmiganur', 'Nellore', 'Proddatur', 'Hindupur', 'Bhimavaram', 'Madanapalle', 'Guntakal', 'Dharmavaram', 'Gudivada', 'Narasaraopet', 'Kadiri', 'Tadipatri', 'Mangalagiri', 'Chilakaluripet'],
        'Arunachal Pradesh': ['Itanagar', 'Tezpur', 'Pasighat', 'Ziro', 'Along', 'Bomdila', 'Tawang', 'Changlang', 'Namsai', 'Seppa', 'Tezu', 'Khonsa', 'Daporijo', 'Naharlagun', 'Roing', 'Anini', 'Longding', 'Koloriang', 'Basar', 'Yingkiong'],
        'Assam': ['Guwahati', 'Silchar', 'Dibrugarh', 'Nagaon', 'Tinsukia', 'Jorhat', 'Barpeta', 'Tezpur', 'Karimganj', 'Sibsagar', 'Diphu', 'North Lakhimpur', 'Hojai', 'Mangaldoi', 'Lumding', 'Haflong', 'Hailakandi', 'Morigaon', 'Nalbari', 'Rangia', 'Silapathar', 'Dhubri', 'Bilasipara', 'Goalpara', 'Bongaigaon', 'Kokrajhar', 'Gossaigaon', 'Abhayapuri', 'Gauripur', 'Golokganj', 'Marigaon', 'Tangla'],
        'Bihar': ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Darbhanga', 'Bihar Sharif', 'Arrah', 'Begusarai', 'Katihar', 'Munger', 'Chhapra', 'Danapur', 'Saharsa', 'Sasaram', 'Hajipur', 'Dehri', 'Siwan', 'Motihari', 'Nawada', 'Bagaha', 'Buxar', 'Kishanganj', 'Sitamarhi', 'Jehanabad', 'Aurangabad', 'Lakhisarai', 'Sheikhpura', 'Supaul', 'Madhepura', 'Gopalganj', 'Bettiah', 'Forbesganj', 'Khagaria', 'Sultanganj', 'Raxaul', 'Bhabua', 'Purnia'],
        'Chhattisgarh': ['Raipur', 'Bhilai Nagar', 'Korba', 'Bilaspur', 'Durg', 'Rajnandgaon', 'Jagdalpur', 'Raigarh', 'Ambikapur', 'Mahasamund', 'Dhamtari', 'Chirmiri', 'Janjgir', 'Sakti', 'Tilda Newra', 'Mungeli', 'Manendragarh', 'Naila Janjgir', 'Bhatapara', 'Dalli-Rajhara', 'Nagarnar', 'Kanker', 'Tilda Neora', 'Dongargarh', 'Akaltara', 'Champa', 'Jashpur Nagar', 'Baloda Bazar', 'Kondagaon', 'Baikunthpur', 'Takhatpur'],
        'Goa': ['Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda', 'Bicholim', 'Curchorem', 'Sanquelim', 'Cuncolim', 'Quepem', 'Canacona', 'Valpoi', 'Pernem', 'Aldona', 'Arambol', 'Anjuna', 'Calangute', 'Candolim', 'Colva', 'Benaulim', 'Cavelossim', 'Majorda', 'Agonda', 'Palolem', 'Patnem', 'Chaudi', 'Cortalim', 'Nuvem', 'Raia', 'Loutolim', 'Chinchinim', 'Assolna'],
        'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Junagadh', 'Gandhinagar', 'Anand', 'Navsari', 'Morbi', 'Nadiad', 'Surendranagar', 'Bharuch', 'Mehsana', 'Bhuj', 'Porbandar', 'Palanpur', 'Valsad', 'Vapi', 'Gondal', 'Veraval', 'Godhra', 'Patan', 'Kalol', 'Dahod', 'Botad', 'Amreli', 'Deesa', 'Jetpur', 'Kadi', 'Bardoli', 'Ankleshwar', 'Modasa', 'Himmatnagar', 'Idar', 'Vyara', 'Keshod', 'Mangrol', 'Dhoraji', 'Upleta', 'Una', 'Sidhpur', 'Wankaner'],
        'Haryana': ['Faridabad', 'Gurgaon', 'Panipat', 'Ambala', 'Yamunanagar', 'Rohtak', 'Hisar', 'Karnal', 'Sonipat', 'Panchkula', 'Bhiwani', 'Sirsa', 'Bahadurgarh', 'Jind', 'Thanesar', 'Kaithal', 'Palwal', 'Rewari', 'Hansi', 'Narnaul', 'Fatehabad', 'Gohana', 'Tohana', 'Narwana', 'Mandi Dabwali', 'Charkhi Dadri', 'Shahbad', 'Pehowa', 'Samalkha', 'Pinjore', 'Ladwa', 'Sohna', 'Safidon', 'Taraori', 'Mahendragarh', 'Ratia', 'Rania', 'Sarsod'],
        'Himachal Pradesh': ['Shimla', 'Mandi', 'Solan', 'Nahan', 'Bilaspur', 'Kullu', 'Hamirpur', 'Una', 'Kangra', 'Dharamshala', 'Palampur', 'Baddi', 'Nalagarh', 'Chamba', 'Sundernagar', 'Paonta Sahib', 'Jogindernagar', 'Rampur Bushahr', 'Jawalamukhi', 'Nurpur', 'Anni', 'Theog', 'Kasauli', 'Gagret', 'Chuari Khas', 'Dalhousie', 'Manali', 'Keylong', 'Rekong Peo', 'Narkanda', 'Sarahan', 'Tattapani', 'Rohru', 'Kotkhai'],
        'Jharkhand': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro Steel City', 'Deoghar', 'Phusro', 'Hazaribagh', 'Giridih', 'Ramgarh', 'Medininagar', 'Chirkunda', 'Pakaur', 'Chaibasa', 'Dumka', 'Sahibganj', 'Jhumri Telaiya', 'Chatra', 'Gumla', 'Simdega', 'Koderma', 'Khunti', 'Bundu', 'Tamar', 'Lohardaga', 'Tenu Dam-cum-Kathhara', 'Ramnagar', 'Nala', 'Rajmahal', 'Mihijam', 'Patratu', 'Barhi', 'Hunterganj', 'Ghatsila', 'Golmuri', 'Jugsalai'],
        'Karnataka': ['Bangalore', 'Hubli-Dharwad', 'Mysore', 'Gulbarga', 'Mangalore', 'Belgaum', 'Davanagere', 'Bellary', 'Bijapur', 'Shimoga', 'Tumkur', 'Raichur', 'Bidar', 'Hospet', 'Hassan', 'Gadag-Betageri', 'Udupi', 'Robertsonpet', 'Bhadravati', 'Chitradurga', 'Kolar', 'Mandya', 'Chikmagalur', 'Gangavati', 'Bagalkot', 'Ranibennur', 'Ranebennuru', 'Karnataka', 'Koppal', 'Mundargi', 'Sirsi', 'Sindhnur', 'Tiptur', 'Arsikere', 'Nanjangud', 'Sagara', 'Sira', 'Puttur', 'Athni', 'Mulbagal', 'Surapura', 'Siruguppa', 'Mudhol', 'Sidlaghatta', 'Shahabad', 'Saundatti-Yellamma', 'Wadi', 'Manvi', 'Nelamangala', 'Lakshmeshwar', 'Jevargi', 'Shiggaon', 'Muddebihal', 'Magadi', 'Rabkavi Banhatti', 'Savanur', 'Ramdurg', 'Shahpur', 'Malavalli', 'Sandur', 'Gurmatkal', 'Ron', 'Chincholi', 'Kollegal', 'Haliyal', 'Dandeli', 'Karwar', 'Brahmavar', 'Karkala'],
        'Kerala': ['Kochi', 'Thiruvananthapuram', 'Kozhikode', 'Kollam', 'Thrissur', 'Palakkad', 'Alappuzha', 'Malappuram', 'Kannur', 'Kasaragod', 'Kottayam', 'Pathanamthitta', 'Idukki', 'Wayanad', 'Ernakulam', 'Thodupuzha', 'Kayamkulam', 'Neyyattinkara', 'Tanur', 'Chalakudy', 'Changanassery', 'Punalur', 'Nilambur', 'Cherthala', 'Perinthalmanna', 'Mattannur', 'Payyannur', 'Kanhangad', 'Koyilandy', 'Parappanangadi', 'Kalamassery', 'Ottappalam', 'Tirur', 'Kodungallur', 'Sreekandapuram', 'Rathinagiri', 'Mananthavady', 'Wadakkanchery', 'Attingal', 'Varkala', 'Paravur', 'Pathanapuram', 'Peringathur', 'Bagalur', 'Milad un Nabi', 'Ponnani', 'Pandalam', 'Manjeri', 'Mavelikkara', 'Perumbavoor', 'Vaikom', 'Palai', 'Panniyannur', 'Guruvayoor', 'Puthuppally'],
        'Madhya Pradesh': ['Indore', 'Bhopal', 'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar', 'Dewas', 'Satna', 'Ratlam', 'Rewa', 'Murwara', 'Singrauli', 'Burhanpur', 'Khandwa', 'Bhind', 'Chhindwara', 'Guna', 'Shivpuri', 'Vidisha', 'Chhatarpur', 'Damoh', 'Mandsaur', 'Khargone', 'Neemuch', 'Pithampur', 'Narmadapuram', 'Itarsi', 'Sehore', 'Betul', 'Seoni', 'Datia', 'Nagda', 'Dindori', 'Ashok Nagar'],
        'Maharashtra': ['Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad', 'Allahabad', 'Solapur', 'Amravati', 'Kolhapur', 'Ulhasnagar', 'Sangli-Miraj & Kupwad', 'Malegaon', 'Akola', 'Latur', 'Dhule', 'Ahmednagar', 'Chandrapur', 'Parbhani', 'Jalgaon', 'Bhusawal', 'Nanded-Waghala', 'Satara', 'Beed', 'Yavatmal', 'Kamptee', 'Gondia', 'Barshi', 'Achalpur', 'Osmanabad', 'Nandurbar', 'Wardha', 'Udgir', 'Hinganghat'],
        'Manipur': ['Imphal', 'Thoubal', 'Lilong', 'Mayang Imphal', 'Lamlong', 'Bishnupur', 'Churachandpur', 'Kakching', 'Senapati', 'Tamenglong', 'Jiribam', 'Chandel', 'Ukhrul', 'Noney', 'Tengnoupal', 'Kamjong', 'Kangpokpi', 'Pherzawl'],
        'Meghalaya': ['Shillong', 'Tura', 'Nongstoin', 'Jowai', 'Baghmara', 'Williamnagar', 'Nongpoh', 'Mairang', 'Mawkyrwat', 'Ampati', 'Resubelpara', 'Khliehriat', 'Amlarem', 'Tikrikilla', 'Cherrapunji', 'Dawki', 'Bholaganj', 'Rongjeng', 'Mendipathar', 'Dadengiri', 'Dalu', 'Mahendraganj', 'Chokpot'],
        'Mizoram': ['Aizawl', 'Lunglei', 'Saiha', 'Champhai', 'Kolasib', 'Serchhip', 'Mamit', 'Lawngtlai', 'Saitual', 'Khawzawl', 'Hnahthial'],
        'Nagaland': ['Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha', 'Zunheboto', 'Phek', 'Kiphire', 'Longleng', 'Peren', 'Mon'],
        'Odisha': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Berhampur', 'Sambalpur', 'Puri', 'Balasore', 'Bhadrak', 'Baripada', 'Jharsuguda', 'Jeypore', 'Barbil', 'Khordha', 'Sunabeda', 'Rayagada', 'Byasanagar', 'Jatani', 'Kendujhar', 'Jagatsinghpur', 'Koraput', 'Kendrapara', 'Paradip', 'Bhawanipatna', 'Dhenkanal', 'Titlagarh', 'Nabarangpur', 'Malkangiri', 'Talcher', 'Bolangir', 'Nuapada', 'Kantabanji', 'Phulbani', 'Nimapara', 'Nayagarh', 'Soro', 'Hinjilikatu', 'Gunupur', 'Rajgangpur', 'Sundargarh', 'Tarbha', 'Belpahar', 'Brajarajnagar', 'Paradeep', 'Jajpur', 'Anandapur', 'Karanjia', 'Basta', 'Udala', 'Basudevpur', 'Chandbali', 'Erasama'],
        'Punjab': ['Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Hoshiarpur', 'Batala', 'Pathankot', 'Moga', 'Abohar', 'Malerkotla', 'Khanna', 'Mohali', 'Barnala', 'Firozpur', 'Phagwara', 'Kapurthala', 'Zirakpur', 'Kotkapura', 'Faridkot', 'Muktsar', 'Rajpura', 'Sangrur', 'Fazilka', 'Gurdaspur', 'Kharar', 'Gobindgarh', 'Mansa', 'Malout', 'Nabha', 'Tarn Taran', 'Jagraon', 'Sunam', 'Dhuri', 'Sirhind Fatehgarh Sahib', 'Rupnagar', 'Jalandhar Cantt', 'Samana', 'Sultanpur Lodhi', 'Longowal', 'Dhilwan', 'Ghanaur'],
        'Rajasthan': ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer', 'Bikaner', 'Alwar', 'Bharatpur', 'Sikar', 'Bhilwara', 'Sri Ganganagar', 'Pali', 'Kishangarh', 'Beawar', 'Jhunjhunu', 'Gangapur City', 'Churu', 'Dhaulpur', 'Hanumangarh', 'Tonk', 'Sawai Madhopur', 'Kuchaman City', 'Makrana', 'Sujangarh', 'Lachhmangarh', 'Rajsamand', 'Nasirabad', 'Nohar', 'Phalodi', 'Nathdwara', 'Taranagar', 'Bundi', 'Lalsot', 'Sardarshahar', 'Ladnu', 'Deshnok', 'Didwana', 'Karauli', 'Suratgarh', 'Kankroli', 'Nimbahera', 'Jalore', 'Nokha', 'Jhalawar', 'Barmer', 'Osian', 'Kishanganj', 'Neem-Ka-Thana', 'Losal', 'Nadbai', 'Shrimadhopura', 'Todaraisingh', 'Reengus', 'Rajakhera', 'Shahpura', 'Raisinghnagar', 'Merta City', 'Kapasan', 'Degana', 'Madanganj-Kishangarh', 'Nagaur', 'Rajgarh (Churu)', 'Ratangarh', 'Sadulshahar', 'Sadri', 'Sanchore', 'Sheoganj', 'Sirohi', 'Sojat', 'Sumel', 'Takhatgarh'],
        'Sikkim': ['Gangtok', 'Namchi', 'Geyzing', 'Mangan', 'Rangpo', 'Singtam', 'Jorethang', 'Nayabazar', 'Gyalshing', 'Yuksom', 'Ravangla', 'Melli', 'Pakyong', 'Rhenock', 'Samdong', 'Soreng', 'Tadong', 'Temi', 'Chungthang', 'Lachen', 'Lachung', 'Yumthang'],
        'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli', 'Tiruppur', 'Ranipet', 'Nagercoil', 'Thanjavur', 'Vellore', 'Kancheepuram', 'Erode', 'Thoothukudi', 'Dindigul', 'Pollachi', 'Rajapalayam', 'Sivakasi', 'Pudukkottai', 'Neyveli (TS)', 'Nagapattinam', 'Viluppuram', 'Tiruchengode', 'Vaniyambadi', 'Theni Allinagaram', 'Udhagamandalam', 'Aruppukkottai', 'Paramakudi', 'Arakkonam', 'Virudhachalam', 'Srivilliputhur', 'Tindivanam', 'Virudhunagar', 'Karur', 'Valparai', 'Sankarankovil', 'Tenkasi', 'Palani', 'Pattukkottai', 'Tirupathur', 'Ramanathapuram', 'Udumalaipettai', 'Gobichettipalayam', 'Thiruvarur', 'Thiruvallur', 'Panruti', 'Namakkal', 'Thirumangalam', 'Vikramasingapuram', 'Attur', 'Sankaridrug', 'Cumbum', 'Thuraiyur', 'Udankudi', 'Manjeri', 'Usilampatti', 'Sulthanbathery', 'Shajapur', 'Vadakkuvalliyur', 'Tirukkoyilur', 'Oddanchatram', 'Palladam', 'Kodaikanal', 'Velur', 'Sholavandan', 'Kumbakonam', 'Hosur', 'Ponneri', 'Vedaranyam', 'Chidambaram', 'Cuddalore', 'Mayiladuthurai', 'Yercaud', 'Kumily', 'Annur', 'Sholinganallur', 'Ambattur', 'Chromepet'],
        'Telangana': ['Hyderabad', 'Warangal', 'Nizamabad', 'Khammam', 'Karimnagar', 'Ramagundam', 'Mahabubnagar', 'Nalgonda', 'Adilabad', 'Suryapet', 'Siddipet', 'Miryalaguda', 'Jagtial', 'Mancherial', 'Gadwal', 'Kothagudem', 'Bodhan', 'Sangareddy', 'Metpally', 'Zahirabad', 'MedChal', 'Jangaon', 'Mandamarri', 'Medak', 'Farooqnagar', 'Tandur', 'Kodad', 'Armoor', 'Wanaparthy', 'Palwancha', 'Banswada', 'Kalwakurthy', 'Nagarkurnool', 'Pargi', 'Vikarabad', 'Jainpur', 'Bhainsa', 'Nirmal', 'Kamareddy', 'Bhongir', 'Yellandu'],

    };
    const [stakeholderId, setStakeholderId] = useState('');

    const [formData, setFormData] = useState({
        // Step 1 - Seller Details
        email: '',
        phone: '',
        legalBusinessName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postal_code: '',
        contactName: '',

        // Step 2 - Stakeholder Details
        stakeholderEmail: '',
        stakeholderPhone: '',
        stakeholderContactName: '',
        pan: '',
        stakeholderAddress1: '',
        stakeholderCity: '',
        stakeholderState: '',
        stakeholderPostalCode: '',

        // Step 3 - Bank Details
        account_number: '',
        ifsc: '',
        beneficiary_name: ''
    });

    // Load saved data on component mount
    useEffect(() => {
        const savedData = localStorage.getItem('paymentAccountSetup');
        if (savedData) {
            const parsedData = JSON.parse(savedData);
            setStepCompleted(parsedData.stepCompleted || { step1: false, step2: false, step3: false });
            setCurrentStep(parsedData.currentStep || 1);
            setFormData(parsedData.formData || formData);
            setAccountId(parsedData.accountId || '');
            setProductId(parsedData.productId || '');
            setStakeholderId(parsedData.stakeholderId || ''); // Add this line
            setOriginalStepData(parsedData.originalStepData || { step1: {}, step2: {}, step3: {} });
        }
    }, []);


    // Save data to localStorage whenever state changes
    const saveProgressToStorage = (updates = {}) => {
        const dataToSave = {
            stepCompleted: updates.stepCompleted || stepCompleted,
            currentStep: updates.currentStep || currentStep,
            formData: updates.formData || formData,
            accountId: updates.accountId || accountId,
            productId: updates.productId || productId,
            stakeholderId: updates.stakeholderId || stakeholderId, // Add this line
            originalStepData: updates.originalStepData || originalStepData
        };
        localStorage.setItem('paymentAccountSetup', JSON.stringify(dataToSave));
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedFormData = {
            ...formData,
            [name]: value
        };
        setFormData(updatedFormData);
        saveProgressToStorage({ formData: updatedFormData });
    };
    const hasEmailChanged = () => {
        return formData.email !== originalStepData.step1.email;
    };

    const hasStepDataChanged = (stepNumber) => {
        if (stepNumber === 1) {
            // For step 1, only check if email has changed
            return hasEmailChanged();
        }

        if (stepNumber === 2) {
            const currentStep2Data = {
                stakeholderEmail: formData.stakeholderEmail,
                stakeholderPhone: formData.stakeholderPhone,
                stakeholderContactName: formData.stakeholderContactName,
                pan: formData.pan,
                stakeholderAddress1: formData.stakeholderAddress1,
                stakeholderCity: formData.stakeholderCity,
                stakeholderState: formData.stakeholderState,
                stakeholderPostalCode: formData.stakeholderPostalCode
            };
            return JSON.stringify(currentStep2Data) !== JSON.stringify(originalStepData.step2);
        }

        if (stepNumber === 3) {
            const currentStep3Data = {
                account_number: formData.account_number,
                ifsc: formData.ifsc,
                beneficiary_name: formData.beneficiary_name
            };
            return JSON.stringify(currentStep3Data) !== JSON.stringify(originalStepData.step3);
        }

        return false;
    };



    const createSeller = async () => {
        // If step is completed but data hasn't changed, just move to next step
        if (stepCompleted.step1 && !hasStepDataChanged(1)) {
            setCurrentStep(2);
            saveProgressToStorage({ currentStep: 2 });
            return;
        }
        const cleanedPhone = formData.phone.replace(/\s+/g, '');

        // Validate phone number (must be 10 digits)
        if (!/^\d{10}$/.test(cleanedPhone)) {
            toast.error("Please enter a valid 10-digit phone number");
            return;
        }

        setLoading(true);
        const business_id = window.localStorage.getItem("business_id");
        try {
            const response = await api.post('/pay/createSeller', {
                email: formData.email,
                phone: cleanedPhone,
                legalBusinessName: formData.legalBusinessName,
                address1: formData.address1,
                address2: formData.address2,
                city: formData.city,
                state: formData.state,
                postal_code: formData.postal_code,
                contactName: formData.contactName,
                business_id: business_id,
                pan: formData.pan,
            });

            if (response.data.accountDetails) {
                const newAccountId = response.data.accountDetails.id;
                setAccountId(newAccountId);

                // Store original data for comparison
                const step1Data = {
                    email: formData.email,
                    phone: cleanedPhone,
                    legalBusinessName: formData.legalBusinessName,
                    address1: formData.address1,
                    address2: formData.address2,
                    city: formData.city,
                    state: formData.state,
                    postal_code: formData.postal_code,
                    contactName: formData.contactName,
                    pan: formData.pan
                };
                setOriginalStepData(prev => ({ ...prev, step1: step1Data }));

                // Auto-fill stakeholder data from business data
                const updatedFormData = {
                    ...formData,
                    stakeholderEmail: formData.email,
                    stakeholderPhone: cleanedPhone,
                    stakeholderContactName: formData.contactName,
                    stakeholderAddress1: formData.address1,
                    stakeholderCity: formData.city,
                    stakeholderState: formData.state,
                    stakeholderPostalCode: formData.postal_code,
                    pan: formData.pan
                };
                setFormData(updatedFormData);

                // Reset subsequent steps if step1 data changed
                const updatedStepCompleted = {
                    step1: true,
                    step2: false,  // Reset step2 since step1 changed
                    step3: false   // Reset step3 since step1 changed
                };
                setStepCompleted(updatedStepCompleted);

                // Save progress before calling stakeholder
                saveProgressToStorage({
                    stepCompleted: updatedStepCompleted,
                    currentStep: 1,
                    formData: updatedFormData,
                    accountId: newAccountId,
                    originalStepData: { ...originalStepData, step1: step1Data }
                });

                toast.success('Seller account created successfully!');

                // Automatically call createStakeholder
                await createStakeholderAuto(newAccountId, updatedFormData);

            } else {
                throw new Error(response.data.message || 'Failed to create seller account');
            }
        } catch (error) {
            console.error('Error creating seller:', error);
            if (error.response?.data?.error?.description) {
                toast.error(error.response.data.error.description);
            } else {
                toast.error('Error creating seller account: ' + (error.response?.data?.message || error.message));
            }
        } finally {
            setLoading(false);
        }
    };

    const createStakeholderAuto = async (accountId, formData) => {
         const business_id = window.localStorage.getItem("business_id");
        try {
            const response = await api.post('/pay/createStakeholders', {
                email: formData.stakeholderEmail,
                phone: formData.stakeholderPhone,
                contactName: formData.stakeholderContactName,
                pan: formData.pan,
                address1: formData.stakeholderAddress1,
                city: formData.stakeholderCity,
                state: formData.stakeholderState,
                postal_code: formData.stakeholderPostalCode,
                account_id: accountId,
                business_id: business_id,
            });

            // Store stakeholder_id from response
            if (response?.data?.stakeholder?.id) {
                setStakeholderId(response?.data?.stakeholder?.id);
            }

            // Store original step2 data
            const step2Data = {
                stakeholderEmail: formData.stakeholderEmail,
                stakeholderPhone: formData.stakeholderPhone,
                stakeholderContactName: formData.stakeholderContactName,
                pan: formData.pan,
                stakeholderAddress1: formData.stakeholderAddress1,
                stakeholderCity: formData.stakeholderCity,
                stakeholderState: formData.stakeholderState,
                stakeholderPostalCode: formData.stakeholderPostalCode
            };
            setOriginalStepData(prev => ({ ...prev, step2: step2Data }));

            const updatedStepCompleted = { ...stepCompleted, step1: true, step2: true };
            setStepCompleted(updatedStepCompleted);
            setCurrentStep(3);

            toast.success('Stakeholder created successfully!');

            // Create product config
            await createProductConfig(accountId);

            // Save progress with stakeholder_id
            saveProgressToStorage({
                stepCompleted: updatedStepCompleted,
                currentStep: 3,
                stakeholderId: response.data.stakeholder_id,
                originalStepData: { ...originalStepData, step2: step2Data }
            });

        } catch (error) {
            console.error('Error creating stakeholder:', error);
            if (error.response?.data?.error?.description) {
                toast.error(error.response.data.error.description);
            } else {
                toast.error('Error creating stakeholder: ' + (error.response?.data?.message || error.message));
            }
            // If stakeholder creation fails, stay on step 2
            setCurrentStep(2);
            saveProgressToStorage({ currentStep: 2 });
        }
    };

    const updateStakeholder = async () => {
        setLoading(true);
        try {
             const business_id = window.localStorage.getItem("business_id");
            const response = await api.post('/pay/updateStakeholders', {
                pan: formData.pan,
                address1: formData.stakeholderAddress1,
                city: formData.stakeholderCity,
                state: formData.stakeholderState,
                postal_code: formData.stakeholderPostalCode,
                account_id: accountId,
                stakeholder_id: stakeholderId,
                business_id: business_id,
            });

            // Update original step2 data with new values
            const step2Data = {
                stakeholderEmail: formData.stakeholderEmail,
                stakeholderPhone: formData.stakeholderPhone,
                stakeholderContactName: formData.stakeholderContactName,
                pan: formData.pan,
                stakeholderAddress1: formData.stakeholderAddress1,
                stakeholderCity: formData.stakeholderCity,
                stakeholderState: formData.stakeholderState,
                stakeholderPostalCode: formData.stakeholderPostalCode
            };
            setOriginalStepData(prev => ({ ...prev, step2: step2Data }));

            toast.success('Stakeholder updated successfully!');
            setCurrentStep(3);
            saveProgressToStorage({
                currentStep: 3,
                originalStepData: { ...originalStepData, step2: step2Data }
            });

        } catch (error) {
            console.error('Error updating stakeholder:', error);
            if (error.response?.data?.error?.description) {
                toast.error(error.response.data.error.description);
            } else {
                toast.error('Error updating stakeholder: ' + (error.response?.data?.message || error.message));
            }
        } finally {
            setLoading(false);
        }
    };



    const createStakeholder = async () => {
        // If step 2 is completed but data hasn't changed, just move to next step
        if (stepCompleted.step2 && !hasStepDataChanged(2)) {
            setCurrentStep(3);
            saveProgressToStorage({ currentStep: 3 });
            return;
        }

        // If step2 is completed and stakeholder_id exists, call update API
        if (stepCompleted.step2 && stakeholderId && hasStepDataChanged(2)) {
            await updateStakeholder();
            return;
        }

        // If step2 is not completed, call create API
        setLoading(true);
        try {
            await createStakeholderAuto(accountId, formData);
        } catch (error) {
            // Error handling is already done in createStakeholderAuto
        } finally {
            setLoading(false);
        }
    };

    const createProductConfig = async (accountId) => {
        try {
            const response = await api.post('/pay/createProductConfig', {
                account_id: accountId
            });

            if (response.data.productConfig) {
                const newProductId = response.data.productConfig.id;
                setProductId(newProductId);
                saveProgressToStorage({ productId: newProductId });
            } else {
                throw new Error(response.data.message || 'Failed to create product config');
            }
        } catch (error) {
            console.error('Error creating product config:', error);
            if (error.response?.data?.error?.description) {
                toast.error(error.response.data.error.description);
            } else {
                toast.error('Error creating product config: ' + (error.response?.data?.message || error.message));
            }
        }
    };

    const updateProductConfig = async () => {
        // If step 3 is already completed, don't call again
        if (stepCompleted.step3) {
            return;
        }
        const business_id = window.localStorage.getItem("business_id");
        setLoading(true);
        try {
            const response = await api.post('/pay/updateProductConfig', {
                account_id: accountId,
                product_id: productId,
                account_number: formData.account_number,
                ifsc: formData.ifsc,
                beneficiary_name: formData.beneficiary_name,
                business_id: business_id
            });

            const updatedStepCompleted = { ...stepCompleted, step3: true };
            setStepCompleted(updatedStepCompleted);
            saveProgressToStorage({ stepCompleted: updatedStepCompleted });

            toast.success('Payment account setup completed successfully!');

            // Save payment account info to your database
            // await savePaymentAccountInfo();

            // Clear saved progress after completion
            localStorage.removeItem('paymentAccountSetup');

            // Redirect to payment page
            setTimeout(() => {
                window.location.href = '/payment';
            }, 2000);
        } catch (error) {
            console.error('Error updating product config:', error);
            if (error.response?.data?.error?.description) {
                toast.error(error.response.data.error.description);
            } else {
                toast.error('Error updating product config: ' + (error.response?.data?.message || error.message));
            }
        } finally {
            setLoading(false);
        }
    };

    const savePaymentAccountInfo = async () => {
        const business_id = window.localStorage.getItem("business_id");
        try {
            await api.post('/business/payment/save', {
                business_id,
                account_id: accountId,
                product_id: productId,
                payment_status: 'active'
            });
        } catch (error) {
            console.error('Error saving payment account info:', error);
            toast.error('Error saving payment account info');
        }
    };

    const handleNext = () => {
        if (currentStep === 1) {
            createSeller();
        } else if (currentStep === 2) {
            createStakeholder();
        } else if (currentStep === 3) {
            updateProductConfig();
        }
    };

    const handlePrevious = () => {
        if (currentStep > 1) {
            const newStep = currentStep - 1;
            setCurrentStep(newStep);
            saveProgressToStorage({ currentStep: newStep });
        }
    };

    // Rest of your component remains the same...
    const renderStepContent = () => {
        // Your existing renderStepContent function stays exactly the same
        switch (currentStep) {
            case 1:
                return (
                    <div className="card-body">
                        <h4>Step 1: Business Information</h4>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Email *</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Phone *</label>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        maxLength={10}
                                        required
                                        disabled={stepCompleted.step1 && !hasEmailChanged()}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Legal Business Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="legalBusinessName"
                                        value={formData.legalBusinessName}
                                        onChange={handleInputChange}
                                        disabled={stepCompleted.step1 && !hasEmailChanged()}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Address Line 1 *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="address1"
                                        value={formData.address1}
                                        onChange={handleInputChange}
                                        disabled={stepCompleted.step1 && !hasEmailChanged()}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Address Line 2</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="address2"
                                        value={formData.address2}
                                        onChange={handleInputChange}
                                        disabled={stepCompleted.step1 && !hasEmailChanged()}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>State *</label>
                                    <select
                                        className="form-control"
                                        name="state"
                                        value={formData.state}
                                        onChange={handleInputChange}
                                        required
                                        disabled={stepCompleted.step1 && !hasEmailChanged()}
                                    >
                                        <option value="">Select State</option>
                                        {statesOfIndia.map((state) => (
                                            <option key={state} value={state}>
                                                {state}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>City *</label>
                                    <select
                                        className="form-control"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleInputChange}
                                        required
                                        disabled={(!formData.state) || (stepCompleted.step1 && !hasEmailChanged())}
                                    >
                                        <option value="">Select City</option>
                                        {formData.state && statesCitiesMap[formData.state]?.map((city) => (
                                            <option key={city} value={city}>
                                                {city}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Postal Code *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="postal_code"
                                        value={formData.postal_code}
                                        onChange={handleInputChange}
                                        required
                                        disabled={stepCompleted.step1 && !hasEmailChanged()}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Contact Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="contactName"
                                        value={formData.contactName}
                                        onChange={handleInputChange}
                                        required
                                        disabled={stepCompleted.step1 && !hasEmailChanged()}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>PAN *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="pan"
                                        value={formData.pan}
                                        onChange={handleInputChange}
                                        required
                                        pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                                        placeholder="ABCDE1234F"
                                        disabled={stepCompleted.step1 && !hasEmailChanged()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );

            case 2:
                return (
                    <div className="card-body">
                        <h4>Step 2: Stakeholder Information</h4>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Email *</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="stakeholderEmail"
                                        value={formData.stakeholderEmail}
                                        onChange={handleInputChange}
                                        required
                                        disabled={stepCompleted.step2}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Phone *</label>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        name="stakeholderPhone"
                                        value={formData.stakeholderPhone}
                                        onChange={handleInputChange}
                                        required
                                        disabled={stepCompleted.step2}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Contact Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="stakeholderContactName"
                                        value={formData.stakeholderContactName}
                                        onChange={handleInputChange}
                                        required
                                        disabled={stepCompleted.step2}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>PAN *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="pan"
                                        value={formData.pan}
                                        onChange={handleInputChange}
                                        required
                                        pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                                        placeholder="ABCDE1234F"
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Address *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="stakeholderAddress1"
                                        value={formData.stakeholderAddress1}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>State *</label>
                                    <select
                                        className="form-control"
                                        name="stakeholderState"
                                        value={formData.stakeholderState}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="">Select State</option>
                                        {statesOfIndia.map((state) => (
                                            <option key={state} value={state}>
                                                {state}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>City *</label>
                                    <select
                                        className="form-control"
                                        name="stakeholderCity"
                                        value={formData.stakeholderCity}
                                        onChange={handleInputChange}
                                        required
                                        disabled={!formData.stakeholderState}
                                    >
                                        <option value="">Select City</option>
                                        {formData.stakeholderState && statesCitiesMap[formData.stakeholderState]?.map((city) => (
                                            <option key={city} value={city}>
                                                {city}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Postal Code *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="stakeholderPostalCode"
                                        value={formData.stakeholderPostalCode}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );

            case 3:
                return (
                    <div className="card-body">
                        <h4>Step 3: Bank Account Details</h4>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Account Number *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="account_number"
                                        value={formData.account_number}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>IFSC Code *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="ifsc"
                                        value={formData.ifsc}
                                        onChange={handleInputChange}
                                        required
                                        pattern="[A-Z]{4}[0-9]{7}"
                                        placeholder="HDFC0000317"
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Beneficiary Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="beneficiary_name"
                                        value={formData.beneficiary_name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <>
            <div className="wrapper" id="root">
                <header>
                    <NavigationBar />
                </header>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1>Create Payment Account</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Progress Steps */}
                                    <div className="card">
                                        <div className="card-header">
                                            {/* Stepper (AdminTheme.css .mtk-steps): ✓ done, highlighted current, muted to come */}
                                            <div className="mtk-steps-count">Step {currentStep} of 3</div>
                                            <ol className="mtk-steps">
                                                {[
                                                    { n: 1, icon: 'fa-building', label: 'Business Info' },
                                                    { n: 2, icon: 'fa-user', label: 'Stakeholder' },
                                                    { n: 3, icon: 'fa-building-columns', label: 'Bank Details' },
                                                ].map(({ n, icon, label }) => {
                                                    const state = currentStep === n ? 'current'
                                                        : (stepCompleted[`step${n}`] || currentStep > n) ? 'done' : 'todo';
                                                    return (
                                                        <li key={n} className={`mtk-step ${state}`} aria-current={state === 'current' ? 'step' : undefined}>
                                                            <span className="dot">
                                                                {state === 'done' ? <i className="fas fa-check" aria-label="Done"></i> : n}
                                                            </span>
                                                            <span className="lbl"><i className={`fas ${icon}`} aria-hidden="true"></i> {label}</span>
                                                        </li>
                                                    );
                                                })}
                                            </ol>
                                        </div>

                                        {renderStepContent()}

                                        <div className="card-footer">
                                            <div className="d-flex justify-content-between">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={handlePrevious}
                                                    disabled={currentStep === 1 || loading}
                                                >
                                                    <i className="fas fa-arrow-left"></i> Previous
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={handleNext}
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <i className="fas fa-spinner fa-spin"></i> Processing...
                                                        </>
                                                    ) : (
                                                        <>
                                                            {stepCompleted[`step${currentStep}`] && !hasStepDataChanged(currentStep) ?
                                                                (currentStep === 3 ? 'Complete Setup' : 'Next') :
                                                                (currentStep === 1 ? 'Create Seller' :
                                                                    currentStep === 2 ?
                                                                        (stepCompleted.step2 && stakeholderId ? 'Update Stakeholder' : 'Create Stakeholder') :
                                                                        'Complete Setup')
                                                            }
                                                            {currentStep !== 3 && <i className="fas fa-arrow-right ml-1"></i>}
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default CreatePaymentAccount;